import { LoaderFunctionArgs, redirect } from "react-router";

export default async function marketplaceProfileLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/marketplace/profiles/individual");
  return routeParams;
}
